import Styled from 'styled-components';

import { media } from '../../lib/StyledComponents';

import { horizontalGutterSize, verticalGutterSize } from './Common';

export const LayoutSplit = Styled.article`
  margin-bottom: ${horizontalGutterSize};
  flex: 0 0 100%;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;

  ${media.medium`
    flex-direction: row;
    flex: 0 0 calc( 50% - ${verticalGutterSize} / 2 );

    &:last-child {
      margin-left: ${verticalGutterSize};
    }
  `}
`;

export default LayoutSplit;

LayoutSplit.displayName = 'LayoutSplit';

export const ConditionalLayoutSplit = Styled(LayoutSplit)`
  display: none;

  ${media.medium`
    display: flex;
  `}
`;

ConditionalLayoutSplit.displayName = 'ConditionalLayoutSplit';
